var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.3994,
    y: 38.3994,
    width: 38.3994,
    height: 38.3994,
    rx: 19.1997,
    transform: "rotate(-180 38.3994 38.3994)",
    fill: "#F4F3F9",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3679 13.3684L18.3679 22.6768L14.3012 18.6101C13.9762 18.2851 13.4429 18.2851 13.1179 18.6101C12.7929 18.9351 12.7929 19.4601 13.1179 19.7851L18.6096 25.2768C18.9346 25.6018 19.4596 25.6018 19.7846 25.2768L25.2846 19.7934C25.6096 19.4684 25.6096 18.9434 25.2846 18.6184C24.9596 18.2934 24.4346 18.2934 24.1096 18.6184L20.0346 22.6768L20.0346 13.3684C20.0346 12.9101 19.6596 12.5351 19.2012 12.5351C18.7429 12.5351 18.3679 12.9101 18.3679 13.3684Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownward);
export default __webpack_public_path__ + "static/media/arrow_downward.f8adc81d2157de92a9a6addc12b74519.svg";
export { ForwardRef as ReactComponent };